<app-toolbar></app-toolbar>
<app-header title="Registrierung" [alignLeft]="true">
  <a [routerLink]="buildSignupBackLink()" class="backButton">
    <markant-button fill="solid" colorScheme="dark">Zurück</markant-button>
  </a>
</app-header>
<div class="signup">
  <div class="container" style="margin: 0 auto">
    <div [class.hidden]="state !== 'process'">
      <div class="process">
        <p>Dein Account wird angelegt...</p>
        <mat-spinner></mat-spinner>
      </div>
    </div>
    <div [class.hidden]="state !== 'submitted'" class="success">
      Vielen Dank für Deine Registrierung! voilà! Die Start-up Arena nutzt den Registrierungsservice der Markant Deutschland GmbH. Du erhältst in Kürze eine
      E-Mail mit Deinem Benutzernamen.
    </div>
    <div [class.hidden]="state !== 'error'">
      <div class="error">
        Entschuldigung! Hier ist leider ein Fehler passiert. Bitte wende dich an
        <a href="mailto:startups@de.markant.com">startups&#64;de.markant.com</a>. Vielen Dank!
      </div>
    </div>
    <div style="position: relative" [class.hidden]="state !== 'form'">
      <h3>Bevor Du Dein Produkt vorstellen kannst, benötigen wir noch einige Informationen</h3>

      <app-stammdaten (notFulfilledRequirements)="this.errorMessage = $event" [initialValue]="initialValue"></app-stammdaten>
      <form [formGroup]="this.signupForm">
        <app-signup-track-lead></app-signup-track-lead>

        <br />
        <markant-checkbox #tosAccepted ngDefaultControl class="checkbox" formControlName="tosAccepted">
          Mit dem Absenden der Registrierung akzeptierst Du unsere
          <a target="_blank" [routerLink]="routes.privacy">Datenschutz-</a> und <a target="_blank" [routerLink]="routes.termsOfUse">Nutzungsbedingungen</a>.
        </markant-checkbox>
        <br />
        <div *ngIf="!signupForm.valid && signupForm.touched">Bitte akzeptiere unsere oben genannten Bedingungen.</div>

        <br />
        <br />

        <markant-button type="submit" class="button button-action" id="submit-registration" (click)="onSubmit()">Registrieren</markant-button>
        <markant-popover for="submit-registration" trigger="click" color-scheme="error" placement="top">
          <div *ngIf="errorMessage.includes('-')" class="popover-content" [textContent]="this.errorMessage"></div>
        </markant-popover>
        <br />
      </form>
    </div>
    <br />
  </div>
</div>
<app-signup-error *ngIf="this.signupError" (closeEvent)="this.signupError = $event"></app-signup-error>
<freshdesk-support [registrationVariant]="true"></freshdesk-support>
